var _defs, _sodipodiNamedview;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 2589.3333,
    height: 925.33331,
    viewBox: "0 0 2589.3333 925.33331",
    sodipodiDocname: "NEW - BAGSID - NoNetwork - DarkBG.ai",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,694 H 1942 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "NEW - BAGSID - NoNetwork - DarkBG",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,925.33333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(335.4785,186.5195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -95.081 c -1.941,0 -3.639,0.697 -5.095,2.092 -1.395,1.395 -2.093,3.094 -2.093,5.095 v 148.672 c 0,2.002 0.698,3.7 2.093,5.095 1.456,1.457 3.154,2.184 5.095,2.184 H 0 Z m 0,257.399 v -71.878 h -95.081 c -1.941,0 -3.639,0.698 -5.095,2.092 -1.395,1.396 -2.093,3.094 -2.093,5.095 v 57.505 c 0,1.94 0.698,3.64 2.093,5.095 1.456,1.395 3.154,2.091 5.095,2.091 z m 0,20.836 h -92.533 v 3.458 c 0,3.701 1.304,6.855 3.912,9.463 2.609,2.67 5.763,4.003 9.463,4.003 H -64.6 0 Z",
    style: {
      fill: "#43abce",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(335.4785,372.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -22.383 h -95.081 c -1.941,0 -3.639,-0.726 -5.095,-2.183 -1.395,-1.396 -2.093,-3.093 -2.093,-5.095 v -148.673 c 0,-2.001 0.698,-3.699 2.093,-5.095 1.456,-1.394 3.154,-2.092 5.095,-2.092 H 0 v -20.835 h -72.971 c -0.498,0.726 -1.073,1.423 -1.728,2.091 -2.972,2.912 -6.521,4.369 -10.646,4.369 -4.125,0 -7.674,-1.457 -10.646,-4.369 -0.655,-0.668 -1.231,-1.365 -1.729,-2.091 h -10.826 c -1.295,0 -2.539,0.121 -3.731,0.364 -3.109,0.68 -5.869,2.228 -8.28,4.639 -3.337,3.336 -5.004,7.34 -5.004,12.01 V 75.61 c 0,4.731 1.667,8.765 5.004,12.101 3.336,3.336 7.339,5.004 12.011,5.004 H -92.533 0 V 71.879 h -95.081 c -1.941,0 -3.639,-0.696 -5.095,-2.092 -1.395,-1.455 -2.093,-3.154 -2.093,-5.095 V 7.187 c 0,-2 0.698,-3.699 2.093,-5.094 C -98.72,0.698 -97.022,0 -95.081,0 Z",
    style: {
      fill: "#bce0ed",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(237.7588,165.6836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.758,-2.506 -2.638,-5.356 -2.638,-8.553 h -6.096 c -1.578,0 -2.942,0.545 -4.095,1.638 -1.152,1.152 -1.729,2.517 -1.729,4.095 V 0.364 C -13.365,0.121 -12.122,0 -10.827,0 Z M 97.72,0 V -8.553 H 27.388 c 0,3.197 -0.88,6.047 -2.639,8.553 z M 54.319,328.006 H 97.72 v -12.011 h -64.6 v 5.277 c 0,1.88 0.667,3.458 2.001,4.731 1.274,1.337 2.851,2.003 4.732,2.003 h 3.002 z m 0,28.387 c -0.217,-0.277 -0.459,-0.549 -0.728,-0.82 -1.395,-1.392 -3.063,-2.091 -5.004,-2.091 -2.002,0 -3.7,0.699 -5.095,2.091 -0.232,0.232 -0.444,0.475 -0.637,0.73 -0.97,1.232 -1.456,2.658 -1.456,4.275 v 6.097 l 0.091,0.819 -0.091,0.818 c 0,4.549 1.638,8.432 4.914,11.647 3.214,3.275 7.126,4.913 11.737,4.913 H 97.72 V 370.587 H 58.05 c -0.667,0 -1.214,-0.212 -1.638,-0.637 -0.486,-0.485 -0.728,-1.03 -0.728,-1.638 l -0.091,-0.818 0.091,-0.819 v -6.097 c 0,-1.567 -0.455,-2.961 -1.365,-4.185",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(235.1206,157.1309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,3.196 0.88,6.047 2.638,8.553 0.498,0.726 1.074,1.424 1.729,2.092 2.972,2.912 6.521,4.368 10.646,4.368 4.125,0 7.674,-1.456 10.646,-4.368 0.654,-0.668 1.23,-1.366 1.728,-2.092 1.759,-2.506 2.639,-5.357 2.639,-8.553 0,-4.125 -1.457,-7.674 -4.367,-10.646 -2.972,-2.912 -6.521,-4.367 -10.646,-4.367 -4.125,0 -7.674,1.455 -10.646,4.367 C 1.456,-7.674 0,-4.125 0,0 M 56.957,364.945 V 336.559 H 45.493 v 28.296 c 0.193,-0.254 0.405,-0.498 0.637,-0.729 1.395,-1.393 3.093,-2.091 5.095,-2.091 1.942,0 3.609,0.698 5.004,2.091 0.269,0.27 0.511,0.543 0.728,0.819",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(335.4785,550.1006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 36.121 c 4.611,0 8.523,-1.638 11.737,-4.913 3.276,-3.215 4.914,-7.098 4.914,-11.648 v -5.914 c 0,-1.698 -0.485,-3.152 -1.455,-4.366 v -30.025 h 5.55 c 1.88,0 3.488,-0.666 4.822,-2.003 1.335,-1.273 2.001,-2.85 2.001,-4.731 v -5.277 h 11.919 c 3.7,0 6.854,-1.333 9.463,-4.002 2.609,-2.609 3.913,-5.764 3.913,-9.463 v -3.459 h 16.014 c 4.67,0 8.673,-1.668 12.009,-5.004 3.338,-3.336 5.004,-7.369 5.004,-12.099 v -264.954 c 0,-4.67 -1.666,-8.674 -5.004,-12.009 -2.425,-2.428 -5.185,-3.974 -8.279,-4.641 v -3.184 c 0,-1.579 -0.576,-2.943 -1.729,-4.094 -1.152,-1.093 -2.517,-1.639 -4.095,-1.639 H 96.81 c 0,-4.125 -1.456,-7.674 -4.368,-10.644 -2.971,-2.913 -6.52,-4.368 -10.645,-4.368 -4.125,0 -7.673,1.455 -10.646,4.368 -2.911,2.97 -4.367,6.519 -4.367,10.644 H 0 v 8.553 20.837 128.927 h 98.629 v 5.185 H 0 98.629 v -5.185 H 0 v 5.185 29.025 22.382 43.037 5.279 23.563 20.836 16.924 12.011 h 39.853 v 30.116 c -0.91,1.212 -1.365,2.639 -1.365,4.275 v 5.914 c 0,0.609 -0.243,1.154 -0.729,1.639 -0.425,0.425 -0.97,0.637 -1.638,0.637 l -36.121,0 z",
    style: {
      fill: "#047096",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(335.4785,371.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 91.532 Z M 0,48.315 H 98.629 Z M 98.629,43.037 H 0 Z M 0,92.715 h 88.985 z m 66.784,-307.624 c 0,3.215 0.88,6.065 2.639,8.553 -1.759,-2.488 -2.639,-5.338 -2.639,-8.553 M 0,109.639 h 63.69 z m 39.853,12.01 h 11.464 z m 0,30.117 c 0.241,-0.302 0.485,-0.576 0.727,-0.82 1.395,-1.394 3.063,-2.092 5.004,-2.092 2.002,0 3.7,0.698 5.095,2.092 0.243,0.244 0.455,0.486 0.638,0.729 -0.183,-0.243 -0.395,-0.485 -0.638,-0.729 -1.395,-1.394 -3.093,-2.092 -5.095,-2.092 -1.941,0 -3.609,0.698 -5.004,2.092 -0.242,0.244 -0.486,0.518 -0.727,0.82 m 54.318,-358.122 c 1.759,-2.488 2.639,-5.338 2.639,-8.553 0,3.215 -0.88,6.065 -2.639,8.553 m -94.171,0 h 69.423 c 0.486,0.726 1.061,1.425 1.728,2.091 2.973,2.913 6.521,4.369 10.646,4.369 4.125,0 7.674,-1.456 10.645,-4.369 0.668,-0.666 1.244,-1.365 1.729,-2.091 h 10.828 c 1.274,0 2.516,0.121 3.73,0.364 -1.214,-0.243 -2.456,-0.364 -3.73,-0.364 H 94.171 c -0.485,0.726 -1.061,1.425 -1.729,2.091 -2.971,2.913 -6.52,4.369 -10.645,4.369 -4.125,0 -7.673,-1.456 -10.646,-4.369 -0.667,-0.666 -1.242,-1.365 -1.728,-2.091 z m 91.532,20.836 c 1.941,0 3.639,0.697 5.095,2.091 1.395,1.396 2.093,3.094 2.093,5.095 v 148.673 -148.673 c 0,-2.001 -0.698,-3.699 -2.093,-5.095 l -5.095,-2.091 H 0 Z M 96.627,2.093 c 1.395,1.395 2.093,3.094 2.093,5.095 V 43.037 7.188 c 0,-2.001 -0.698,-3.7 -2.093,-5.095 L 91.532,0 c 1.941,0 3.639,0.698 5.095,2.093 m 2.093,46.222 v 16.377 c 0,1.941 -0.698,3.64 -2.093,5.095 1.395,-1.455 2.093,-3.154 2.093,-5.095 V 48.315 H 98.629 V 43.037 H 98.72 Z M 0,-22.383 h 91.532 c 1.941,0 3.639,-0.726 5.095,-2.183 l 2.093,-5.095 c 0,2.003 -0.698,3.699 -2.093,5.095 -1.456,1.457 -3.154,2.183 -5.095,2.183 z m 91.532,94.262 5.095,-2.092 c -1.456,1.396 -3.154,2.092 -5.095,2.092 H 0 Z",
    style: {
      fill: "#047096",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 335.479,414.622 H 233.21 v 5.278 h 102.269 z m 0,-99.63 H 233.21 v 5.186 h 102.269 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(335.4785,371.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 91.532 M 0,48.315 H 98.629 M 0,-185.52 H 91.532 M 0,92.715 H 88.985 M 66.784,-214.909 c 0,3.215 0.88,6.065 2.639,8.553 M 0,109.639 h 63.69 m -23.837,12.01 h 11.464 m -11.464,30.117 c 0.241,-0.302 0.485,-0.576 0.727,-0.82 1.395,-1.394 3.063,-2.092 5.004,-2.092 2.002,0 3.7,0.698 5.095,2.092 0.243,0.244 0.455,0.486 0.638,0.729 m 42.854,-358.031 c 1.759,-2.488 2.639,-5.338 2.639,-8.553 M 0,-206.356 h 69.423 c 0.486,0.726 1.061,1.425 1.728,2.091 2.973,2.913 6.521,4.369 10.646,4.369 4.125,0 7.674,-1.456 10.645,-4.369 0.668,-0.666 1.244,-1.365 1.729,-2.091 h 10.828 c 1.274,0 2.516,0.121 3.73,0.364 m -17.197,20.472 c 1.941,0 3.639,0.697 5.095,2.091 m 0,0 c 1.395,1.396 2.093,3.094 2.093,5.095 V -29.661 M 0,-51.407 h 98.629 v -5.186 H 0 m 98.72,26.932 c 0,2.003 -0.698,3.699 -2.093,5.095 -1.456,1.457 -3.154,2.183 -5.095,2.183 H 0 M 91.532,0 c 1.941,0 3.639,0.698 5.095,2.093 1.395,1.395 2.093,3.094 2.093,5.095 v 35.849 m 0,0 v 5.278 16.377 c 0,1.941 -0.698,3.64 -2.093,5.095 M 98.629,48.315 V 43.037 H 0 m 0,78.612 h 39.853 v 30.117 c -0.91,1.212 -1.365,2.638 -1.365,4.275 v 5.914 c 0,0.608 -0.243,1.153 -0.729,1.639 -0.425,0.425 -0.97,0.636 -1.638,0.636 H 0 m 0,14.286 h 36.121 c 4.611,0 8.523,-1.638 11.737,-4.913 3.276,-3.215 4.914,-7.098 4.914,-11.648 v -5.914 c 0,-1.698 -0.485,-3.152 -1.455,-4.366 v -30.026 h 5.55 c 1.88,0 3.488,-0.666 4.822,-2.003 1.335,-1.272 2.001,-2.849 2.001,-4.73 v -5.277 h 11.919 c 3.7,0 6.854,-1.333 9.463,-4.002 2.609,-2.61 3.913,-5.764 3.913,-9.463 v -3.459 h 16.014 c 4.67,0 8.673,-1.668 12.009,-5.004 3.338,-3.336 5.004,-7.369 5.004,-12.1 v -264.954 c 0,-4.67 -1.666,-8.674 -5.004,-12.009 -2.425,-2.427 -5.185,-3.973 -8.279,-4.64 v -3.185 c 0,-1.578 -0.576,-2.942 -1.729,-4.094 -1.152,-1.092 -2.517,-1.638 -4.095,-1.638 H 96.81 c 0,-4.125 -1.456,-7.674 -4.368,-10.645 -2.971,-2.913 -6.52,-4.368 -10.645,-4.368 -4.125,0 -7.673,1.455 -10.646,4.368 -2.911,2.971 -4.367,6.52 -4.367,10.645 H 0 M 96.627,69.787 c -1.456,1.396 -3.154,2.092 -5.095,2.092 H 0",
    style: {
      fill: "none",
      stroke: "#a4d1e7",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(115.2915,157.3115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 19.562 V -44.583 C 19.319,-52.71 23.566,-56.957 32.3,-57.321 H 61.871 V -74.608 H 30.936 C 11.221,-75.154 0.91,-66.661 0,-49.133 Z m 421.996,0 h 19.562 v -49.133 c -0.91,-17.528 -11.223,-26.021 -30.936,-25.475 h -30.935 v 17.287 h 29.57 c 8.735,0.364 12.98,4.611 12.739,12.738 z M 61.871,438.373 H 32.3 C 23.566,438.009 19.319,433.764 19.562,425.636 V 381.052 H 0 v 49.133 c 0.91,17.529 11.221,26.021 30.936,25.476 h 30.935 z m 317.816,17.288 h 30.935 c 19.713,0.545 30.026,-7.947 30.936,-25.476 v -49.133 h -19.562 v 44.584 c 0.241,8.128 -4.004,12.373 -12.739,12.737 h -29.57 z",
    style: {
      fill: "#bce0ed",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(853.9326,284.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.518,6.101 12.777,14.653 12.777,25.656 0,10.829 -4.303,19.25 -12.906,25.269 -8.607,6.015 -20.566,9.025 -35.88,9.025 H -93.056 V -9.153 h 57.047 C -20.521,-9.153 -8.519,-6.104 0,0 m -6.324,84.059 c 7.054,5.584 10.583,13.537 10.583,23.85 0,9.968 -3.529,17.703 -10.583,23.206 -7.059,5.5 -16.952,8.163 -29.685,7.993 H -93.056 V 75.679 h 57.047 c 12.733,0 22.626,2.792 29.685,8.38 M 7.228,143.363 C 17.464,135.37 22.586,124.323 22.586,110.23 22.586,99.569 19.618,90.634 13.681,83.414 7.744,76.194 -0.561,71.464 -11.229,69.232 2.021,67.512 12.346,62.613 19.747,54.535 27.144,46.453 30.846,36.228 30.846,23.852 30.846,8.381 25.079,-3.653 13.552,-12.247 2.021,-20.845 -13.983,-25.14 -34.46,-25.14 h -76.407 v 180.494 h 75.632 c 18.069,0 32.222,-3.998 42.463,-11.991",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(1035.0098,323.3066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -43.367,97.466 -86.217,0 Z M 6.969,-15.986 H -93.186 l -21.166,-47.96 h -19.102 l 81.311,180.235 h 18.584 L 47.754,-63.946 H 28.393 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(1234.7988,347.5439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 15.746 v -66.009 c -8.776,-7.392 -18.973,-13.194 -30.588,-17.404 -11.616,-4.215 -23.45,-6.317 -35.493,-6.317 -17.037,0 -32.742,4.125 -47.108,12.376 -14.371,8.251 -25.774,19.423 -34.203,33.52 -8.433,14.093 -12.648,29.48 -12.648,46.154 0,16.672 4.215,31.974 12.648,45.898 8.429,13.924 19.917,24.967 34.46,33.133 14.54,8.163 30.415,12.248 47.625,12.248 12.217,0 24.046,-2.152 35.494,-6.447 C -2.625,82.854 7.486,76.839 16.263,69.104 L 5.937,56.469 c -7.401,6.873 -15.919,12.159 -25.554,15.857 -9.64,3.695 -19.618,5.544 -29.944,5.544 -13.939,0 -26.76,-3.396 -38.461,-10.185 -11.705,-6.792 -20.998,-15.947 -27.878,-27.46 -6.885,-11.519 -10.326,-24.154 -10.326,-37.905 0,-13.924 3.441,-26.686 10.326,-38.29 6.88,-11.602 16.217,-20.801 28.007,-27.59 11.786,-6.792 24.652,-10.184 38.59,-10.184 8.604,0 17.166,1.418 25.685,4.255 8.517,2.836 16.39,6.832 23.618,11.989 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(1378.833,420.9014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.776,2.49 -17.036,3.739 -24.78,3.739 -12.391,0 -22.328,-2.45 -29.814,-7.348 -7.486,-4.9 -11.229,-11.564 -11.229,-19.984 0,-7.393 2.065,-13.408 6.195,-18.05 4.13,-4.64 9.204,-8.295 15.23,-10.958 6.022,-2.667 14.282,-5.632 24.781,-8.895 12.217,-3.61 22.069,-7.18 29.555,-10.701 7.486,-3.526 13.85,-8.638 19.102,-15.342 5.247,-6.704 7.873,-15.56 7.873,-26.559 0,-9.629 -2.711,-18.137 -8.131,-25.526 -5.421,-7.393 -13.036,-13.11 -22.845,-17.147 -9.809,-4.041 -21.082,-6.059 -33.815,-6.059 -12.563,0 -24.824,2.489 -36.783,7.477 -11.963,4.984 -22.243,11.603 -30.847,19.855 l 8.26,14.697 c 8.087,-7.909 17.465,-14.097 28.137,-18.565 10.668,-4.472 21.167,-6.704 31.491,-6.704 13.766,0 24.692,2.792 32.783,8.38 8.087,5.584 12.132,13.106 12.132,22.561 0,7.563 -2.066,13.751 -6.195,18.566 -4.13,4.81 -9.208,8.508 -15.23,11.086 -6.025,2.58 -14.455,5.584 -25.297,9.026 -12.22,3.778 -22.029,7.348 -29.427,10.7 -7.401,3.353 -13.68,8.336 -18.843,14.955 -5.162,6.615 -7.743,15.253 -7.743,25.914 0,9.11 2.581,17.103 7.743,23.98 5.163,6.873 12.39,12.159 21.683,15.857 9.292,3.694 20.045,5.544 32.266,5.544 9.81,0 19.658,-1.463 29.557,-4.384 9.893,-2.925 18.625,-6.792 26.2,-11.602 L 24.265,-10.7 C 16.863,-6.06 8.776,-2.494 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1500.409,259.36 h -53.691 v 180.751 h 53.691 z",
    style: {
      fill: "#bce0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(1641.3447,314.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 7.57,8.767 11.358,20.369 11.358,34.809 0,14.439 -4.046,26.128 -12.132,35.067 -8.091,8.937 -18.585,13.408 -31.492,13.408 H -56.788 V -13.15 h 27.103 C -17.468,-13.15 -7.574,-8.768 0,0 M 19.747,114.354 C 34.461,106.877 45.858,96.306 53.949,82.64 62.036,68.974 66.081,53.2 66.081,35.324 66.081,17.444 61.951,1.631 53.691,-12.119 45.431,-25.874 33.815,-36.485 18.844,-43.963 3.872,-51.44 -13.423,-55.18 -33.04,-55.18 h -77.439 v 180.751 h 79.246 c 19.27,0 36.267,-3.739 50.98,-11.217",
    style: {
      fill: "#bce0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.2fe7b8a74562356a1709924824c64c19.svg";
export { ForwardRef as ReactComponent };